export var PaymentProviders = {
  CAMS: 'cams'
};